export default {
  // Sizes
  panelWidth: 250
};
